<template>
  <div class="DropTarget">
    <div class="DropTarget_Content">
      <div class="DropTarget_Text">Drop here</div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue } from "vue-property-decorator";

const DropTarget = Vue.extend({
  props: {},

  data() {
    return {};
  },
});
export default DropTarget;
</script>

<style scoped lang="scss">
.DropTarget {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(2px);

  .DropTarget_Content {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;

    .DropTarget_Text {
      text-align: center;
      color: var(--text-dark-supplemental);
    }
  }
}
</style>
